export function gradeSorter(knownGrades: string[]) {
  return (a: string, b: string) => {
    const aIndex = knownGrades.indexOf(a);
    const bIndex = knownGrades.indexOf(b);
    if (aIndex === -1 && bIndex === -1) {
      return a.localeCompare(b); // if both are unknown, sort by name
    }
    if (aIndex === -1) {
      return 1; // place it at the end if unknown
    }
    return aIndex - bIndex;
  };
}
